import React from 'react';
import '../less/sepa-new.less';
import '../less/transfers.less';
import hero_img from '../img/sepa/hero_img.png';
import Hero from '../../../../../auxiliary-components/shared/HeroBlock';
import QuestionsAdminNew from '../../../../../auxiliary-components/shared/QuestionsAdminNew';
import FAQStorybook from '@abank/abank-faq';
import InfoBlock from '../../../../../auxiliary-components/shared/InfoBlock';
import TransferTableNew from '../../../../../auxiliary-components/shared/TransfersTableNew';
import tariffsData from '../../../../../../API/transfers/sepa/tariffs.json';
import FilesForDownloadNew from '../../../../../auxiliary-components/shared/FilesForDownloadNew';
import requisitesItems from '../enums/sepa/requisites_items.json';
import TitleBlock from '../../../../../auxiliary-components/shared/TitleBlock';
import { filterByEnvironment } from '../../../../../helpers/utils/environmentFilter';

export default function template() {
    const page = 'sepa';

    const hero_data = {
      title: 'SEPA_NEW_HERO_TITLE',
      text: 'SEPA_NEW_HERO_TEXT',
    }

    const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');

    return (
      <div className="sepa-new">
        <Hero
          data={hero_data}
          img={hero_img}
          className="transfers"
        />
        <div className="content">
          {!this.state.faqTab ? (
            <>
              <div className="first-info-block">
                <TitleBlock title={'SEPA_NEW_GET_TRANSFER_TITLE'}/>
                <InfoBlock 
                  text={'SEPA_NEW_INFO_TEXT_01'}
                />
              </div>
              <div className="get-requisites">
                <div className="container">
                  <h2 className="get-requisites__title">{this.l10n('SEPA_NEW_GET_REQUISITES_TITLE')}</h2>
                  <div className="get-requisites__body">
                    {requisitesItems.map(({ title, text }, index) => (
                      <div key={index} className="get-requisites__item item-get-requisites">
                        <div className="item-get-requisites__title">{this.l10n(title)}</div>
                        <div className="item-get-requisites__text">{this.l10n(text)}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <InfoBlock 
                text={'SEPA_NEW_INFO_TEXT_02'}
              />
              <TransferTableNew 
                data={tariffsData}
                title={'SEPA_NEW_TARIFFS_TITLE'}
              />
              <QuestionsAdminNew
                widget={questionsWidget}
                toggleFaqTab={this.toggleFaqTab}
                title={'SEPA_NEW_QUESTIONS_ADMIN_TITLE'}
                page={page}
              />
              <FilesForDownloadNew
                widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}
              />
            </>
          ) : (
            <FAQStorybook
              widget={questionsWidget}
              title={this.l10n('SEPA_NEW_FAQ_STORYBOOK_TITLE')}
              btnText={this.l10n('SEPA_NEW_FAQ_STORYBOOK_BTN_TEXT')}
              onBtnClick={this.toggleFaqTab}
              filterByEnvironment={filterByEnvironment}
            />
          )}
        </div>
      </div>
    );
}
